<template>
  <div class="smart-phone" data-type="default">
    <a :href="linkHref">{{phoneNumber}}</a>
  </div>
</template>

<script>
import { phone } from '@/data/snippets/companyInfo';

export default {

  name: 'SmartPhone',

  data() {
    return {
      phoneNumber: phone,
    };
  },

  computed: {

    intlPhoneNumber() {
      // transform to "international" format
      return phone.replace(/\./gi, '-');
    },

    linkHref() {
      return `tel:${this.intlPhoneNumber}`;
    },

  },

};
</script>

<style lang="scss" scoped>
@import '~@/styles/_typography.scss';

.smart-phone {
  width: 100%;
  line-height: rem(16px);
  margin-bottom: rem(50px);

  a {
    color: $color--primary-midtone;
    @include sansserif( $size: (16, 16, 0), $weight: 'light');
    // margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SmartPhone.vue